<ng-container *transloco="let t">
  <div
    class="p-dialog-with-toolbar common-lookup-dialog lookup-dialog-content"
    [ngClass]="lookupId"
    [formGroup]="form"
    (keydown.enter)="applyFilters()"
  >
    <div class="grid condensed-row">
      <div class="col-12 filters">
        <p-accordion>
          <p-accordionTab header="{{ t('facility.facility_lookup_dialog.tabs.filters') }}" [selected]="true">
            <!-- first row -->
            <div class="p-fluid grid condensed-row">
              <div class="field lg:col-3 col-12">
                <input
                  zTextInput
                  zAutoFocus
                  formControlName="facility"
                  label="{{ t('facility.facility_lookup_dialog.filters.facility.label') }}"
                  placeholder="{{ t('facility.facility_lookup_dialog.filters.facility.placeholder') }}"
                  styleClass="w-full"
                  [uppercase]="true"
                  [clearButton]="true"
                  [matchTypes]="true"
                  (matchTypeChange)="onMatchTypeChange('facility', $event)"
                  defaultMatchType="startsWith"
                />
              </div>

              <div class="field lg:col-3 col-12">
                <input
                  zTextInput
                  formControlName="name"
                  label="{{ t('facility.facility_lookup_dialog.filters.name.label') }}"
                  placeholder="{{ t('facility.facility_lookup_dialog.filters.name.placeholder') }}"
                  styleClass="w-full"
                  [uppercase]="true"
                  [clearButton]="true"
                  [matchTypes]="true"
                  (matchTypeChange)="onMatchTypeChange('name', $event)"
                  defaultMatchType="startsWith"
                />
              </div>

              <div class="field lg:col-3 col-12">
                <z-combo-box
                  [list]="stateOrProvinceList$ | async"
                  label="{{ t('facility.facility_lookup_dialog.filters.state_or_province.label') }}"
                  placeholder="{{ t('facility.facility_lookup_dialog.filters.state_or_province.placeholder') }}"
                  fieldName="stateOrProvince"
                  [columnsConfig]="{
                    column1: { dropdown: { width: 60 } }
                  }"
                >
                </z-combo-box>
              </div>

              <div class="field lg:col-3 col-12 flex justify-content-end align-self-end">
                <button
                  pButton
                  type="button"
                  icon="fad fa-check"
                  label="{{ t('facility.facility_lookup_dialog.filters.apply_filters') }}"
                  class="p-button-outlined"
                  (click)="applyFilters()"
                  style="width: auto"
                ></button>

                <button
                  pButton
                  type="button"
                  icon="fad fa-undo-alt"
                  label="{{ t('facility.facility_lookup_dialog.filters.reset') }}"
                  class="p-button-secondary p-button-outlined ml-2"
                  (click)="reset()"
                  style="width: auto"
                ></button>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      <div class="col-12 grid-table overflow-hidden">
        <z-facility-lookup-dialog-grid></z-facility-lookup-dialog-grid>
      </div>
    </div>

    <div class="p-dialog-footer p-dialog-footer-toolbar">
      <p-toolbar styleClass="dialog-toolbar" [formGroup]="form">
        <div class="p-toolbar-group-left md:flex hidden">
          <z-legend type="form" [showHeader]="false">
            <z-legend-entry
              color="grey"
              label="{{ t('facility.facility_lookup_dialog.legend.inactive.label') }}"
              title="{{ t('facility.facility_lookup_dialog.legend.inactive.title') }}"
              styleClass="ml-1"
            ></z-legend-entry>
          </z-legend>
        </div>

        <div class="p-toolbar-group-right">
          <p-button
            label="{{ t('facility.facility_lookup_dialog.dialog.select') }}"
            styleClass="ml-1 p-button-primary"
            (click)="onSelectClick()"
          ></p-button>
          <p-button
            label="{{ t('facility.facility_lookup_dialog.dialog.cancel') }}"
            styleClass="ml-1 p-button-secondary"
            (click)="onCancelClick()"
          ></p-button>
        </div>
      </p-toolbar>
    </div>
  </div>
</ng-container>
